import { Email, from } from '@phi/newtype';
import { DataLayer } from '../datalayer';

export const log_user_login = (datalayer: DataLayer | Error) => (email: Email, source: 'phi' | 'onshape') => {
    if (datalayer instanceof Error)
        return;
    else
        datalayer.push({
            'event': 'OnLogin',
            'sourcePlatform': source,
            'email': from(email),
        });
};
